
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.PolicyView">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-policy-view [caseId]="data.caseId" (closed)="close()"></app-policy-view>
      </mat-dialog-content>
</div>
